<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue
      code="enseignement-francais"
      v-model="permisPsychologue.enseignementEnFrancais"
      :live="liveSasPermisPsychologue(2109)"
    ></opq-catalogue>
    <opq-catalogue code="examens-francais" v-model="permisPsychologue.examensFrancais" :live="liveSasPermisPsychologue(2110)"></opq-catalogue>
    <opq-catalogue
      code="etudes-secondaires"
      v-model="permisPsychologue.certificatEtudesSecondairesACompter1985_1986"
      :live="liveSasPermisPsychologue(2111)"
    ></opq-catalogue>
    <opq-alert v-show="tousNon" type="info" code="attestation-oqlf"></opq-alert>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [CataloguesHelper, FormSimple],

  props: {
    sas: { type: Object }
  },

  methods: {
    liveSasPermisPsychologue(cle) {
      return { endpoint: "sas-permis-psychologue", cle: cle, fileId: this.permisPsychologue.id }
    }
  },

  computed: {
    permisPsychologue() {
      return this.sas.permisPsychologue
    },
    tousNon() {
      return (
        this.estNon(this.permisPsychologue.enseignementEnFrancais) &&
        this.estNon(this.permisPsychologue.examensFrancais) &&
        this.estNon(this.permisPsychologue.certificatEtudesSecondairesACompter1985_1986)
      )
    }
  }
}
</script>

<style>
</style>